import { render } from "./orchestra-item.vue?vue&type=template&id=5cd55d67"
import script from "./orchestra-item.vue?vue&type=script&lang=js"
export * from "./orchestra-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__